var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCertificateCheck = function SvgIconCertificateCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#30B7FD",
    d: "M6 16h6v2H6zm0-4h10v2H6zm0-4h10v2H6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#092B49",
    d: "M14 26H4V6h24v10h2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h10z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#092B49",
    d: "M22 25.59 19.41 23 18 24.41l4 4 8-8L28.59 19z"
  })));
};
export default SvgIconCertificateCheck;